import type { CSSProperties } from "react";
import { AvailabilityOverviewUnavailableReason } from "api/scheduling/types";

export const SHOWING_AVAILABILITY_TAB_LABEL = "Showing availability";

// Fallback display band, mirroring the backend's base band
// (DISPLAY_BAND_START_HOUR = 9, DISPLAY_BAND_END_HOUR = 23). The effective
// band comes from the response (band_start_hour / band_end_hour — the backend
// expands it outward to cover the team's configured windows); these values
// are only used before the first response arrives.
export const BAND_START_HOUR = 9;
export const BAND_END_HOUR = 23;

// Pixel height of one hour row in the timeline, per the Figma spec.
export const HOUR_ROW_PX = 88;

// Fixed member-column width (px), horizontally scrollable, per the Figma spec.
export const MEMBER_COLUMN_PX = 164;

// Solid fill for available regions (design: plain green, no border or label).
export const AVAILABLE_FILL_CLASS = "bg-success-100";

// Diagonal hatch for unavailable regions, per the Figma spec (135° lines in
// #1C1D22 at 5% opacity). Inline style because Tailwind has no hatch token.
export const UNAVAILABLE_HATCH_STYLE: CSSProperties = {
  backgroundImage:
    "repeating-linear-gradient(135deg, rgba(28, 29, 34, 0.05) 0px, rgba(28, 29, 34, 0.05) 1px, transparent 1px, transparent 7px)"
};

// Tooltip subtitle per unavailable-reason category. "outside_hours" is
// templated with the member's name in the component. Unknown categories fall
// back to no subtitle (the "Unavailable <range>" title alone).
export const UNAVAILABLE_REASON_COPY: Record<
  AvailabilityOverviewUnavailableReason,
  string
> = {
  outside_hours: "Outside {name} daily hours",
  conflict: "Calendar conflict",
  buffer: "Buffer time around another commitment"
};
